export default function AdminPageHeader({ eyebrow, title, description, actions }) {
    return (
        <div
            data-testid="admin-page-header"
            className="border-b border-[#0F1F38]/10 bg-white"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-10 py-8 md:py-10 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
                <div>
                    {eyebrow && (
                        <div className="text-[10px] tracking-label uppercase text-[#0F1F38]/50 mb-3">
                            {eyebrow}
                        </div>
                    )}
                    <h1 className="font-display text-3xl md:text-4xl leading-[1.05] text-[#0F1F38]">
                        {title}
                    </h1>
                    {description && (
                        <p className="mt-3 max-w-2xl text-sm text-[#4B5563] leading-relaxed">
                            {description}
                        </p>
                    )}
                </div>
                {actions && <div className="flex items-center gap-3">{actions}</div>}
            </div>
        </div>
    );
}
